import { Fragment, useRef } from 'react';
import { Button } from '@devopsafs/react-ui-components';

import { Key } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';
import useKeyUp from 'src/hooks/use-key-up';
import useOnClickOutside from 'src/hooks/use-on-click-outside';
import type { PopupMausoleumBankProps } from './popup-mausoleum-bank.props';

import './popup-mausoleum-bank.scss';

const PopupMausoleumBank = ({
  bank,
  bankTypeLabel,
  isLoading,
  position,
  statRows,
  onClose,
  onSelectBank,
}: PopupMausoleumBankProps) => {
  const { getLocalization } = useLocalization();
  const modalRef = useRef<HTMLDivElement | null>(null);
  const positionStyle = {
    '--popup-mausoleum-bank-x': `${position.x}px`,
    '--popup-mausoleum-bank-y': `${position.y}px`,
  } as React.CSSProperties;

  useOnClickOutside(modalRef, onClose);
  useKeyUp(Key.ESCAPE, onClose);

  return (
    <div
      className="popup-mausoleum-bank scrollbar"
      ref={modalRef}
      aria-label={getLocalization('Selected Bank Details')}
      aria-modal
      role="dialog"
      style={positionStyle}
    >
      <div className="popup-mausoleum-bank__header">
        <p className="popup-mausoleum-bank__title">{bank.name}</p>
        {bank.bank_type && bankTypeLabel && (
          <p className="popup-mausoleum-bank__type">{getLocalization(bankTypeLabel)}</p>
        )}
      </div>

      {isLoading ? (
        <p className="popup-mausoleum-bank__text">{getLocalization('Loading')}...</p>
      ) : statRows.length ? (
        <>
          <div className="popup-mausoleum-bank__stats">
            {statRows.map((stat) => (
              <Fragment key={stat.id}>
                <div className="popup-mausoleum-bank__stat-label">
                  {getLocalization(stat.label)}:
                </div>
                <div className="popup-mausoleum-bank__stat-value">
                  <span className="popup-mausoleum-bank__stat-available">{stat.available}</span> /{' '}
                  {stat.all}
                </div>
              </Fragment>
            ))}
          </div>

          <Button
            className="popup-mausoleum-bank__button"
            label={getLocalization('Lots').toUpperCase()}
            tag="button"
            theme="outlined"
            onClick={() => onSelectBank(bank.id)}
          />
        </>
      ) : (
        <p className="popup-mausoleum-bank__text">{getLocalization('No Lots Found')}</p>
      )}
    </div>
  );
};

export default PopupMausoleumBank;
